import React, { FC, useCallback, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterRow, Lookup, Pager, Paging, Summary, TotalItem } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { useAuth } from 'context/auth';

import { AppCard, AppLayoutTop } from '../../../../../../../components/appComponents';
import $createStore from '../../../../../../../utils/create-store-instance';
import { CreateEditModal, DeleteModal } from './components';

const ComingNomenclatureTransport: FC = () => {
  let { id } = useParams<{ id: string }>();
  const { getClaims }: any = useAuth();

  const transportDataStore: any = useMemo(() => {
    return $createStore(`/v1/ComingNomenclature/${id}/details`, 'id');
  }, [id]);

  const factoryFullNames = useMemo(() => {
    return $createStore('/v1/factory/fullNames', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);

  const [visibleModal, setVisibleModal] = useState(false);
  const [transportId, setTransportId] = useState<number | null>(null);
  const refreshGrid = useCallback(() => refGrid.current?.instance.refresh(), []);

  const isCanEditComingNomenclatureTransports = getClaims(['CanEditComingNomenclatureTransports']);

  return (
    <div className="container-dev">
      <AppLayoutTop title="">
        <Button
          width={120}
          text="Создать"
          type="default"
          visible={isCanEditComingNomenclatureTransports}
          onClick={() => {
            setTransportId(null);
            setVisibleModal(true);
          }}
        />
      </AppLayoutTop>

      {visibleModal && (
        <CreateEditModal
          changeVisible={setVisibleModal}
          id={transportId}
          refresh={refreshGrid}
          visible={visibleModal}
          commingId={Number(id)}
        />
      )}
      {visibleDeleteModal && (
        <DeleteModal
          changeVisible={setVisibleDeleteModal}
          id={transportId}
          refresh={refreshGrid}
          visible={visibleDeleteModal}
        />
      )}

      <AppCard>
        <DataGrid
          dataSource={transportDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          remoteOperations
        >
          <FilterRow visible={true} />
          <Column dataField="id" caption="Номер" sortOrder="asc" width={90} />
          <Column dataField="date" caption="Дата" dataType="date" />
          <Column dataField="factoryId" caption="Склад">
            <Lookup dataSource={factoryFullNames} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="driver" caption="Водитель" />
          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="trailer" caption="Прицеп" />
          <Column dataField="quantity" caption="Кол-во" width={200} />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            visible={isCanEditComingNomenclatureTransports}
            width={120}
            cellRender={(data) => (
              <>
                <Button
                  icon="edit"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setTransportId(data.data.id);
                    setVisibleModal(true);
                  }}
                />
                <Button
                  icon="trash"
                  type="default"
                  stylingMode="text"
                  onClick={() => {
                    setVisibleDeleteModal(true);
                    setTransportId(data.data.id);
                  }}
                />
              </>
            )}
          />
          <Summary>
            <TotalItem
              column="quantity"
              summaryType="sum"
              valueFormat="decimal"
              displayFormat="Итого: {0}"
              customizeText={(data: any) => `${data.value.toFixed(3)}`}
            />
          </Summary>
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ComingNomenclatureTransport;
